<plyca-layout>
  <ng-template #panelTemplate>
    <navigation />
    <div id="page-wrapper" class="white-bg" app-layout-subheader>
      <p-confirmDialog [header]="'General.info' | translate" icon="pi pi-exclamation-triangle" [acceptLabel]="'General.accept' | translate" [rejectLabel]="'General.cancel' | translate" />
      <topnavbar class="basic__container-topnavbar" />
      <sub-header class="basic__container-subheader" />
      <router-outlet />
      <footer></footer>
    </div>
  </ng-template>
</plyca-layout>
